<template>
  <div>
    <div id="download-links">
      Get your player search view 
      <a href="https://steamcommunity.com/sharedfiles/filedetails/?id=3125858261&result=1" target="_blank">from Steam</a> 
      or <a href="/assets/Rate-My-Tactic_1.0.fmf" download="Rate-My-Tactic_1.0.fmf" target="_blank">directly</a>.<br>
      Follow the instructions 
      <a href="https://steamcommunity.com/sharedfiles/filedetails/?id=3125858261&result=1" target="_blank">here</a>
      to get it into your game.
    </div>
    <div
      id="file-drop-step-container"
      :class="{'--ready-to-drop': inDropZone}"
      @dragover.prevent="handleDragOver"
      @dragenter.prevent="handleDragOver"
      @dragleave="handleDragLeave"
      @dragend="handleDragLeave"
      @drop="handleFileDrop">
      <p>{{ $t("ui.teamAttributes.dragOrBrowseHint") }}:</p>

      <div class="file-upload-container">
        <label for="file-upload" class="custom-file-upload capitalise">
            {{ $t("ui.teamAttributes.browse") }}...
        </label>
        <input 
          id="file-upload"
          type="file"
          class="file-input"
          ref="fileInput"
          accept=".html"
          @change="handleFileSelect" />
      </div>

    </div>
  </div>
</template>

<script>
import {parseHTMLFile} from "@/leaguePlayerAttributeFileParsing.js"
import {rankAttributes} from "@/leaguePlayerAttributeEvaluation.js"

export default {
  data: function() {
    return {
      inDropZone: false,
    };
  },

  methods: {
    handleFileUpload(file) {
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = readerEvent => {
        let playerData;
        try {
          playerData = parseHTMLFile(readerEvent.target.result);
        } catch (err) {
          console.error("Parsing error!", err);
          this.$refs.fileInput.value = "";
          return;
        }
        this.$emit("update:allTeams", rankAttributes(playerData));
      }
    },

    handleFileDrop(e) {
      e.preventDefault();
      this.handleFileUpload(e.dataTransfer.files[0])
    },

    handleFileSelect(e) {
      this.handleFileUpload(e.target.files[0])
    },

    handleDragOver() {
      this.inDropZone = true;
    },

    handleDragLeave() {
      this.inDropZone = false;
    }
  }
}
</script>

<style scoped>
#download-links {
  margin-bottom: 12px;
}

#download-links a {
  color: #fff;
}

#file-drop-step-container {
  border: dashed 1px rgba(255, 255, 255, 0.75);
  border-radius: 4px;
  padding: 24px 40px;
}

#file-drop-step-container.--ready-to-drop {
  background: #181818;
}

.file-upload-container {
  margin: 48px;
}

.file-input {
  display: none;
}

.custom-file-upload {
  margin: 4px;
  padding: 6px 16px;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
  background: #226CB8;
}

.custom-file-upload:hover {
  filter: brightness(1.2);
}

.capitalise {
  text-transform: capitalize;
}
</style>
